module.exports = __webpack_public_path__ + "593a3d53/img/dollar-icon.35c9d638.svg";